import React, { Component } from 'react';
// import ReactGA from 'react-ga';

export default function withTracker(WrappedComponent, options = {}) {
	// const trackPage = (page) => {
	//	 ReactGA.set({
	//		 page,
	//		 ...options
	//	 });
	//	 // console.log('window.location.href::',window.location.href,window.location.href.indexOf('localhost'));
	//	 if(window.location.href.indexOf('localhost') > 0)
	//		 ReactGA.pageview(page);
	// };

	const HOC = class extends Component {
		setPageAndSendToGA = (url) => {
			// console.log('Tracking page::',url);
			window.ga('set', 'page', url);
			window.ga('send', 'pageview');
		};

		componentDidMount() {
			/**
			const page = this.props.location.pathname;
			if(window.location.href.indexOf('localhost') > 0)
				trackPage(page);
			 /* */
			this.setPageAndSendToGA(this.props.location.pathname);
		}

		componentWillReceiveProps(nextProps) {
			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			if (currentPage !== nextPage) {
				/**
				if(window.location.href.indexOf('localhost') > 0)
					trackPage(nextPage);
				 /* */
				this.setPageAndSendToGA(nextPage);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	return HOC;
}
